/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgSemi48(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={48}
      height={48}
      fill='none'
      viewBox='0 0 48 48'
      {...props}
    >
      <path
        fill='#D6F5FF'
        fillRule='evenodd'
        d='M1.5 42.5V40h45.2v2.5H1.5zm15.5-7l.038-3.154c2.634-.505 5.896-3.261 7.162-7.846l.008.027c1.27 4.569 4.326 7.314 6.954 7.82L31.2 35.5H17zm25.684-21H46.7V18h-4.017v-3.5zm-37.167 0H1.5V18h4.016v-3.5zM24 7h-2v6.065h2V7z'
      />
      <path
        fill='currentColor'
        fillRule='evenodd'
        stroke='currentColor'
        strokeLinecap='square'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M3.7 42.5v3.053c0 .799.648 1.447 1.447 1.447h3.605c.8 0 1.448-.648 1.448-1.447V42.5H3.7zm40.8 0v3.053c0 .799-.648 1.447-1.448 1.447h-3.605c-.8 0-1.447-.648-1.447-1.447V42.5h6.5z'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M17.5 24.5H5.186a.75.75 0 00-.747.684L3.5 35.8h11'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M3.5 35.8l.39-4.3H12v4.3'
      />
      <path
        stroke='currentColor'
        strokeLinecap='square'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M6.75 1v2.5h2.678c.178 0 .322.144.322.321V6.5h2.75V3.753A2.754 2.754 0 009.746 1H6.75z'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M6 24.5V21h3.75V9.5H1.5V18h4.415V9.5M30.7 24.5h12.314a.75.75 0 01.746.684L44.7 35.8h-11'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M44.7 35.8l-.5-4.3h-8v4.3'
      />
      <path
        stroke='currentColor'
        strokeLinecap='square'
        strokeLinejoin='round'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M17 35.8V20.787a1.5 1.5 0 011.168-1.463L24 18l6.023 1.33a1.5 1.5 0 011.177 1.465V35.8'
      />
      <path
        stroke='currentColor'
        strokeLinecap='square'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M9.75 24.5v-18h28.7v18'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M9.75 16.521L24 13.5l14.45 3.021'
      />
      <path
        stroke='currentColor'
        strokeLinecap='square'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M41.45 1v2.5h-2.678a.322.322 0 00-.322.321V6.5H35.7V3.753A2.754 2.754 0 0138.453 1h2.997zM1.5 35.8h45.2v6.7H1.5v-6.7z'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M42.2 24.5V21h-3.75V9.5h8.25V18h-4.415V9.5'
      />
      <path
        stroke='currentColor'
        strokeLinecap='square'
        strokeLinejoin='round'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M24 7v5.5'
      />
      <path
        stroke='currentColor'
        strokeLinecap='square'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M24 35.8V18.5'
      />
    </svg>
  );
}

export default SvgSemi48;
